import React from 'react'

import Base from '../_Base'

const Premium = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="m22 7.97-3.337 11.463H5.487L2 7.955l6.345 2.835L12.085 5l3.615 5.785L22 7.97zm-4.946 9.32 1.593-5.474-3.776 1.687-2.816-4.505-2.906 4.5-3.731-1.667 1.658 5.458h9.978z"
      fillRule="evenodd"
    />
  </Base>
)

export default Premium
